export const state = () => ({
  newsWordPress: [],
  media: [],
  newSelected: [],
})
export const getters = {
  allNewsWP: (state) => state.newsWordPress,
  mediaSelectedWP: (state) => state.media,
  newSelected: (state) => state.media,
  WPSelected: (state) => (slug) => {
    return state.newsWordPress.find((e) => e.slug === slug)
  },
}

export const mutations = {
  SET_NEWS: (state, payload) => (state.newsWordPress = payload),
  SET_NEWS_MEDIA_SELECTED: (state, payload) => (state.media = payload),
  SET_NEWS_SELECTED: (state, payload) => (state.media = payload),
}

export const actions = {
  async fetchNewsWP({ commit }, { page = 1, perPage = 8 }) {
    const data = await this.$axios.$get(
      `https://blogcd.com.br/wp-json/wp/v2/posts?page=${page}&per_page=${perPage}`
    )
    commit('SET_NEWS', data)
    return data
  },
  // Seletor de 1 unica media de noticia
  async fetchNewsWPMediaSelected({ commit }, parentId) {
    const data = await this.$axios.$get(
      `https://blogcd.com.br/wp-json/wp/v2/media?parent=${parentId}`
    )
    commit('SET_NEWS_MEDIA_SELECTED', data)
  },

  // Seletor de 1 unica noticia
  async fetchNewsWPSelected({ commit }, parentId) {
    const data = await this.$axios.$get(
      `https://blogcd.com.br/wp-json/wp/v2/posts/${parentId}`
    )
    commit('SET_NEWS_SELECTED', data)
  },
}
